import {React, useEffect, useState, Fragment} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {Paper, Grid, Typography, Zoom, Fab, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress} from '@material-ui/core/'
import {authFetch, logout} from '../../auth';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(2)
    },
    sectionTitle: {
        marginBottom: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 3,
        padding: 4
    },
    contentPaper:{
        background: theme.palette.secondary.light,
        padding: 16,
    },
    dialogContent: {
        fontSize: 14,
        color: theme.palette.primary.main,
    },
    dialogTitle: {
        fontSize: 14,
        color: theme.palette.primary.main,
        fontWeight: 'normal'
    },
    formText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "center",        
    },
    uploadButton : {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 8,
        },
    }
}));

export default function ClientControl (props) {
    const classes = useStyles();    
    const [feedbackDialog, setFeedbackDialog] = useState(false);
    const [feedbackMsg, setFeedbackMsg] = useState("");        
    const [downloadInProgress, setDownloadInProgress] = useState(false);

    let billingPeriod = props.billingDate; // Objeto Date o String de fecha

    const handleFeedbackDialogOpen = () => {
        setFeedbackDialog(true);
    };
    
    const handleFeedbackDialogClose = () => {
        setFeedbackDialog(false);
    };

    const showFeedbackDialog = () => (
        <Dialog
            open={feedbackDialog}
            onClose={handleFeedbackDialogClose}       
            className={classes.formText}            
        >
            <DialogTitle className={classes.dialogTitle} style={{textAlign: 'center'}}>Aviso</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <DialogContentText>
                    {feedbackMsg}
                </DialogContentText>
            </DialogContent>
            <DialogActions>          
                <Button onClick={handleFeedbackDialogClose} color="primary" autoFocus>
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    );

    const downloadAgpeReport = () => {
        setDownloadInProgress(true);

        const year = billingPeriod ? new Date(billingPeriod).getFullYear() : new Date().getFullYear();
        const month = billingPeriod ? new Date(billingPeriod).getMonth() + 1 : new Date().getMonth() + 1;
        const clientCode = props.client_code || '';

        const urlParams = new URLSearchParams({
            username: String(props.username),
            year: String(year),
            month: String(month),
            client_code: String(clientCode),
            timestamp: new Date().toISOString().slice(0, 19)
        });

        authFetch(`/api/download-agpe-excedentes-csv?${urlParams.toString()}`, { responseType: 'blob' })
        .then(response => {
            if (response.status === 422) { 
                logout(); 
                setDownloadInProgress(false);
                return null; 
            } else if (response.status !== 200) {
                handleFeedbackDialogOpen();
                setFeedbackMsg("Error en la descarga del reporte AGPE_FrtSinReporteASIC.");    
                setDownloadInProgress(false);
                return null;
            }
            return response.blob();
        })
        .then(blob => {                 
            setDownloadInProgress(false);
            if (!blob) return;

            const monthStr = month < 10 ? '0' + month : month;
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;    
            a.download = `AGPE_FrtSinReporteASIC.csv`;
            
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);                                                                          
        })
        .catch(() => {
            setDownloadInProgress(false);
            handleFeedbackDialogOpen();
            setFeedbackMsg("Ocurrió un error al intentar descargar el archivo.");
        });
    };

    useEffect(() => {
        document.title = "Reporte AGPE FrtSinReporteASIC";
    }, []);

    return (
        <div className={classes.root}>
            {showFeedbackDialog()}            
            <Zoom in timeout={800}>
                <Grid container justify="center" spacing={2}>                    
                    <Grid item xs={12} sm={8} md={6}>
                        <Typography variant="subtitle1" className={classes.sectionTitle} color="primary" align="center">
                            Reporte AGPE_FrtSinReporteASIC
                        </Typography>
                        <Paper className={classes.contentPaper} elevation={0} variant="outlined">
                            <Grid container direction="column" alignItems="center" justify="center" spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="body2" color="primary" align="center" style={{ marginBottom: 10 }}>
                                        Descarga de información de excedentes y créditos de energía (.csv)
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    {downloadInProgress ? (
                                        <CircularProgress size={30} />
                                    ) : (
                                        <Fab 
                                            color="primary" 
                                            variant="extended" 
                                            classes={{ root: classes.uploadButton }}
                                            onClick={downloadAgpeReport}
                                        >
                                            <Fragment>
                                                <ArrowDropDownCircleIcon style={{ marginRight: 8 }} />
                                                Descargar AGPE_FrtSinReporteASIC
                                            </Fragment>
                                        </Fab>
                                    )}
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Zoom>
        </div>
    );
}